"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gsnRuntimeVersion = '2.2.6';
exports.gsnRequiredVersion = '^2.2.0';
//# sourceMappingURL=Version.js.map